import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('report', [booksMenu])
  .controller('communitiesReportController', Controller)
  .name;

/** Utility method to get the response data. */
/* @ngInject */ function getData(resp) {
  return resp.data;
}

/* @ngInject */ function Controller($q, $scope, BooksSvc, BusyScreen) {
  /** csmValidators Object. */ $scope.validators = {};
  /** Request Model. */ $scope.req = { reportFormat: 'PDF' };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  $q.all({
    org: BooksSvc.getOrganization().then(getData),
    sites: BooksSvc.getChildSites().then(getData)
  }).then(function (resolves) {
    $scope.org = resolves.org;
    $scope.sites = [resolves.org].concat(resolves.sites);

    BusyScreen.setBusy(false);
  });
}
